// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-6eeea28e] {\n  font-size: 23px;\n  color: #B5C3BC;\n}", ""]);
// Exports
module.exports = exports;
